module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGPHOENIX-6b9a2312bef27359a62cddae69329f17.png";